import { useEffect } from 'react';
import Raven from 'raven-js';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export function useCaptureError(error, {
  message,
  extra,
  alert
} = {
  message: ''
}) {
  useEffect(() => {
    if (error) {
      Raven.captureException(error, {
        extra: Object.assign({
          message
        }, extra)
      });
      if (alert) {
        FloatingAlertStore.addAlert(Object.assign({
          type: 'danger'
        }, alert));
      }
    }
  }, [error, message, extra, alert]);
}